export default __webpack_public_path__ + "static/media/alarm-bell.001fa984.svg";